import styled from 'styled-components'

export const PaymentsContainer = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
    margin-bottom: 0;
    height: 400px;
    @media only screen and (min-width: 810px) {
        gap: 2rem;
        flex-direction: row;
        justify-content: center;
    }
`

export const PaymentsHeader = styled.header`
    width: 100%;
    margin: 0.5rem 0;
`
